import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    // 屏幕大小区分大屏小屏
    isMaxScreen: null,
    pageData: null // 存储个人信息页面的数据
  },
  actions: {
    toggleScreen ({ commit }, payload) {
      commit('toggle_screen', payload)
    }
  },
  mutations: {
    toggle_screen (state, payload) {
      state.isMaxScreen = payload
    },
    setPageData(state, data) {
      state.pageData = data
    },
    clearPageData(state) {
      state.pageData = null
    }
  }
})

export default store
